export default {
      id: "drop-gradient-usage",
      viewBox: "0 0 424 512",
      url: __webpack_public_path__ + "img/svg-sprite.svg#drop-gradient",
      toString: function () {
        return this.url;
      }
    }